import type { ILayerProps } from '@/version-types';

export interface ILayerAnimationFrame {
    opacity: number;
    offsetX: number;
    offsetY: number;
    complete: boolean;
}

const DEFAULT_DURATION = 0.2;

/**
 * 计算图层入场动画在指定时间的绘制状态。
 * 当前 Canvas 播放模式与旧 DOM 的 default-in 动画保持一致。
 */
export function getLayerAnimationFrame(
    animation: ILayerProps['__animation'],
    elapsedSeconds: number,
): ILayerAnimationFrame {
    if (!animation?.enabled || !animation.name) {
        return { opacity: 1, offsetX: 0, offsetY: 0, complete: true };
    }

    const delay = Math.max(0, animation.delay || 0);
    const duration = Math.max(0, animation.duration || DEFAULT_DURATION);
    const linearProgress = duration === 0 ? 1 : Math.min(1, Math.max(0, (elapsedSeconds - delay) / duration));
    // CSS ease-in 的轻量近似，保持前慢后快的视觉节奏。
    const progress = linearProgress * linearProgress;
    const isDefaultIn = animation.name === 'default-in';

    if (linearProgress >= 1) {
        return { opacity: 1, offsetX: 0, offsetY: 0, complete: true };
    }

    return {
        opacity: progress,
        offsetX: isDefaultIn ? -30 * (1 - progress) : 0,
        offsetY: isDefaultIn ? -2 * (1 - progress) : 0,
        complete: false,
    };
}
